document.addEventListener('DOMContentLoaded', function(event) {

  gsap.registerPlugin(Draggable);

  var tentingDegrees = [{
    degree: 5, dashOffSet: 165, reverse: false
  }, {
    degree: 10, dashOffSet: 202, reverse: false
  }, {
    degree: 15, dashOffSet: 243, reverse: false
  },{
    degree: 20, dashOffSet: 295, reverse: false
  }, {
    degree: 25, dashOffSet: 347, reverse: false
  }, {
    degree: 35, dashOffSet: 387, reverse: false
  }, {
    degree: 45, dashOffSet: 424, reverse: false
  }, {
    degree: 60, dashOffSet: 470, reverse: false
  }]

  var animationStep = 0;
  var wrapperTentingAngles = document.querySelector('.defy-tenting-angles');
  var imagesTenting = wrapperTentingAngles.querySelectorAll('.defy-kb-item');
  var degrees = document.querySelector('.tenting-angle-degrees');
  var animateProgressPositive = document.querySelector('.defy-meter');
  var tentingDirection = document.querySelector('.tenting-direction');

  //var imageCanvas = document.querySelector('#imageCanvas');
  //var imageContext = imageCanvas.getContext("2d");
  //var pointerImage = new Image();
  
  var listImagesUrl = document.querySelectorAll('.image-tenting');

  var degreeImages = [];
  listImagesUrl.forEach((item) => {
    pointerURL = item.dataset.url;
    degreeImages.push(pointerURL);
    //console.log(degreeImages);
  });

  var intervalID = setInterval(triggerTentingAnimation, 1000);


  function triggerTentingAnimation() {
    
    //pointerImage.src = degreeImages[animationStep];
    //imageContext.clearRect(0, 0, imageCanvas.width, imageCanvas.height);
    //pointerImage.onload =  function(){imageContext.drawImage(pointerImage, 0, 0);}
    
    
    //console.log(degreeImages[animationStep]);
    //console.log('Steps', animationStep);

    listImagesUrl.forEach((item) => {
      if (animationStep == parseInt(item.dataset.index)) {
       if(!item.classList.contains('active')) {
         item.classList.add('active');
       }
      } else {
        item.classList.remove('active');
      }
    });
    
    tentingDirection.textContent = "Positive tenting";
    wrapperTentingAngles.style.setProperty('--tenting-angle', `${tentingDegrees[animationStep].degree}deg`);
    animateProgressPositive.style.setProperty('--dash-reverse', '-190');
    animateProgressPositive.style.setProperty('--dash', tentingDegrees[animationStep].dashOffSet);
    
    // Set the starting and ending values
    const startValue = (animationStep == 0) ? tentingDegrees[tentingDegrees.length - 1].degree : tentingDegrees[animationStep -1].degree;
    const endValue = tentingDegrees[animationStep].degree;
    animateText(parseInt(startValue), parseInt(endValue));
    
    
    if (animationStep < tentingDegrees.length - 1) {
      animationStep++;  
    } else {
      animationStep = 0;  
    }
    //window.requestAnimationFrame(animateImages);
    
  }

  function animateText(initialNumber, lastNumber) {
    const startValue = initialNumber;
    const endValue = lastNumber;
    
    // Set the duration of the animation (in milliseconds)
    const animationDuration = 250;
    
    // Get the current timestamp
    const startTime = Date.now();
    
    // Define the animation function
    function animate() {
      // Get the elapsed time since the animation started
      const elapsedTime = Date.now() - startTime;
      
      // Calculate the progress of the animation
      const progress = Math.min(elapsedTime / animationDuration, 1);
      
      // Calculate the current value based on the progress
      const currentValue = Math.floor(startValue + (endValue - startValue) * progress);
      
      // Update the display with the current value
      degrees.textContent = currentValue;
      
      // Check if the animation is complete
      if (progress < 1) {
        // Request another animation frame
        requestAnimationFrame(animate);
      }
    }
    
    // Start the animation
    animate();
  }

  

  // const draggable = new Draggable(document.createElement('div') , {
  //   trigger: document.querySelector(".drag-knob"),
  //   throwProps: true,
  //   onDrag: updateProgress,
  //   onThrowUpdate: updateProgress,
  //   bounds: document.querySelector(".drag-area"),
  //   type: x,
  //   liveSnap: { 
  //     x: [0, 26, 52, 78, 104, 130, 156, 182, 208, 234, 260, 286]
  //   }
  // });

  var dragKnob = document.querySelector(".drag-knob");
  var dragTrigger = document.querySelector(".drag-inner");
  var dragArea = document.querySelector(".drag-area");

  Draggable.create(dragKnob, {
    trigger: dragTrigger,
    onDrag: updateProgress,
    bounds: dragArea,
    type: 'x',
    liveSnap: { 
      x: [20, 60, 100, 140, 180, 220, 260, 300]
    }
  });
  

  function updateProgress() {
    //console.log('Update on drag: ', this.x);
    clearInterval(intervalID);
    switch (this.x) {
      case 20:
        animationStep = 7;
        triggerTentingAnimation();
        break;
      case 60:
        animationStep = 6;
        triggerTentingAnimation();
        break;
      case 100:
          animationStep = 5;
          triggerTentingAnimation();
          break;
      case 140:
        animationStep = 4;
        triggerTentingAnimation();
        break;
      case 180:
        animationStep = 3;
        triggerTentingAnimation();
        break;
      case 220:
        animationStep = 2;
        triggerTentingAnimation();
        break;
      case 260:
        animationStep = 1;
        triggerTentingAnimation();
        break;
      case 300:
        animationStep = 0;
        triggerTentingAnimation();
        break;
      
    }
  }

});